import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { pickToken } from '../../../styles/helper';
export const formFieldContainerStyles = ({ theme, $size }) => css `
	display: flex;
	gap: ${pxToRem(theme.spacing['100'])};
	flex-direction: column;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		${$size === 's' &&
    css `
			grid-column-end: span 1;
		`}

		${$size === 'm' &&
    css `
			grid-column-end: span 2;
		`}

    ${$size === 'l' &&
    css `
			grid-column-end: span 3;
		`}

    ${$size === 'xl' &&
    css `
			grid-column-end: span 4;
		`}
	}
`;
export const FormFieldContainer = styled.div `
	${formFieldContainerStyles}
`;
/**
 * FormField Error
 */
export const formFieldErrorContainerStyles = ({ theme, $colorContext, }) => css `
	white-space: pre-line;
	color: ${theme.colors.error.textFieldValidation};

	${$colorContext === 'on-dark' &&
    css `
		color: ${theme.colors.error.textFieldValidationInverse};
	`}
`;
export const FormFieldErrorContainer = styled(Typography).attrs({
    tagName: 'div',
    variant: 'field-validation',
}) `
	${formFieldErrorContainerStyles}
`;
/**
 * FormField Info
 */
export const formFieldInfoContainerStyles = ({ theme, $colorContext, $color, }) => css `
	margin: 0;
	color: ${pickToken({
    'on-light': theme.colors.base.textSupport,
    'on-medium': theme.colors.base.textSupport,
    'on-dark': theme.colors.blanc.textSupportInverse,
}, $colorContext)};

	${$color === 'error' &&
    css `
		color: ${$colorContext === 'on-dark'
        ? theme.colors.error.textFieldValidationInverse
        : theme.colors.error.textSupport};
	`}
	${$color === 'success' &&
    css `
		color: ${$colorContext === 'on-dark'
        ? theme.colors.positive.textFieldValidationInverse
        : theme.colors.positive.textSupport};
	`}
`;
export const FormFieldInfoContainer = styled(Typography).attrs({
    variant: 'support-text',
}) `
	${formFieldInfoContainerStyles}
`;
